import { render } from "./CoinRecord.vue?vue&type=template&id=fdfe9988&scoped=true"
import script from "./CoinRecord.vue?vue&type=script&lang=js"
export * from "./CoinRecord.vue?vue&type=script&lang=js"

import "./CoinRecord.vue?vue&type=style&index=0&id=fdfe9988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfe9988"]])

export default __exports__